import cx from 'classnames';
import React, { Component, useEffect, useState } from 'react';
import type { RefObject } from 'react';

import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useButton } from '@react-aria/button';

import { useOverlayTriggerState } from '@react-stately/overlays';

import { Popover } from '../../../popover';
import FieldCheckboxGroup from '../field-checkbox-group';

export interface IProps {
  containerClassName?: string;
  displayMember: string;
  fieldClassName?: string;
  inputClassName?: string;
  label?: string;
  options: any[];
  selected: any[];
  valueMember: string;
  wrapperClassName?: string;

  onChange?: (checked: boolean, optionChecked: any) => void;
}

export interface IOption {
  label: string;
  value: boolean;
}

const FieldSelectCheckBoxAria: React.FC<IProps> = (props) => {
  const {
    containerClassName,
    displayMember,
    fieldClassName,
    inputClassName,
    label,
    options,
    selected,
    valueMember,
    wrapperClassName,
    onChange
  } = props;

  const [isTransform, setIsTransform] = useState(false);

  let state = useOverlayTriggerState({});
  const { isOpen, open, close } = state;

  let triggerRef = React.useRef() as RefObject<HTMLButtonElement>;

  const handleBlur = React.useCallback(() => {
    setIsTransform(false);
  }, []);

  let { buttonProps } = useButton(
    {
      onBlur: handleBlur
    },
    triggerRef
  );

  const handleActiveClick = React.useCallback(() => {
    !isOpen && !isTransform && open();
    isOpen && isTransform && setIsTransform(false);
  }, [isOpen, isTransform, open]);

  useEffect(() => {
    isOpen && setIsTransform(isOpen);
  }, [isOpen]);

  useEffect(() => {
    !isTransform &&
      setTimeout(() => {
        close();
      }, 300);
  }, [isTransform]);

  if (options.length === 0) {
    return null;
  }

  return (
    <>
      <button
        {...buttonProps}
        ref={triggerRef}
        className={cx('w-full outline-none', containerClassName)}
      >
        <div className={wrapperClassName}>
          <div
            className={cx(
              fieldClassName,
              'mb-0 flex cursor-pointer items-center justify-between bg-white px-3',
              {
                'rounded-none rounded-t-md': isOpen
              }
            )}
            onClick={handleActiveClick}
          >
            <label className="cursor-pointer">{label}</label>
            <FontAwesomeIcon
              aria-hidden="true"
              icon={isOpen ? faChevronUp : faChevronDown}
              className="fa-md fa-fw"
            />
          </div>
        </div>
        {state.isOpen && (
          <Popover isOpen={state.isOpen} onClose={state.close}>
            {options.length > 0 && (
              <ul
                className={cx(
                  'origin-top scale-y-0 transform rounded-b-md border-2  border-t-0 border-gray-200  bg-white px-4 py-2 transition duration-300',
                  {
                    'scale-y-100': isTransform
                  }
                )}
              >
                <FieldCheckboxGroup
                  options={options}
                  handleChange={onChange}
                  selected={selected}
                  valueMember={valueMember}
                  displayMember={displayMember}
                  inputClassName={inputClassName}
                />
              </ul>
            )}
          </Popover>
        )}
      </button>
    </>
  );
};

class FieldSelectCheckBox extends Component<IProps> {
  static defaultProps = {
    displayMember: 'label',
    inputClassName: 'my-1',
    options: [],
    selected: [],
    valueMember: 'label'
  };

  render() {
    return <FieldSelectCheckBoxAria {...this.props} />;
  }
}
export default FieldSelectCheckBox;
